import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import DowntimeTable from "components/property-market/downtime/downtime-table"
// Data
import api_match from "data/interface/api"
import importService from "data/import"
import downtimeService from "data/downtime"
import propertyService from 'data/property.ts'
import { alphanum } from "components/table/lib/sort"
//Styles
import { Downtime_s } from "components/property-market/downtime/downtime-styles"
import { AddIcon } from "images/icons/tools"

const Downtime: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "downtime-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const downtimeSubscription = downtimeService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    return function cleanup() {
      downtimeSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    downtimeService.fetchDowntime(propertyId)
    propertyService.fetchProperty(propertyId)

  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => downtimeService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <Downtime_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="downtime" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport && <DowntimeTable tableId={tableId} data={data} /> }
    </Downtime_s>
  )
}

export default Downtime
